import React from "react";
import { ShoppingBag, MapPin } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { LOGO_URL } from "@/lib/api";

export default function Header() {
  const { count, setOpen } = useCart();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/70 border-b border-border">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2.5" data-testid="brand-logo">
          <img src={LOGO_URL} alt="Paulista's Lanches & Pizzas" className="h-11 w-auto object-contain" />
          <div className="leading-none hidden sm:block">
            <p className="font-display font-black text-lg tracking-tight">Paulista's Lanches &amp; Pizzas</p>
            <p className="flex items-center gap-1 text-xs text-muted-foreground mt-0.5">
              <MapPin className="w-3 h-3" /> Rua José Pequeno 50, Alto Alegre
            </p>
          </div>
        </a>
        <button
          onClick={() => setOpen(true)}
          data-testid="open-cart-btn"
          className="relative inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-4 py-2 text-sm font-semibold hover:bg-primary/90 transition-colors"
        >
          <ShoppingBag className="w-4 h-4" />
          <span className="hidden sm:inline">Meu pedido</span>
          {count > 0 && (
            <span
              data-testid="cart-count"
              className="absolute -top-2 -right-2 grid place-items-center min-w-5 h-5 px-1 rounded-full bg-secondary text-secondary-foreground text-xs font-bold"
            >
              {count}
            </span>
          )}
        </button>
      </div>
    </header>
  );
}
